import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgBusyModule } from 'ng-busy';
import { TranslateModule } from '@ngx-translate/core';

import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import { PaymentModule } from '../payment/payment.module';
import { UnifiedOrderInfoTableModule } from '../unified-order-info-table/unified-order-info-table.module';

import {
  PaymentRequestDetailsComponent
} from './components/payment-request-details/payment-request-details.component';
import { OrderExtraPaymentComponent }
  from './components/order-extra-payment/order-extra-payment.component';


@NgModule({
  declarations: [
    OrderExtraPaymentComponent,
    PaymentRequestDetailsComponent,
  ],
  imports: [
    CommonModule,
    NgBusyModule,
    PaymentModule,
    TranslateModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    UnifiedOrderInfoTableModule,
  ],
  exports: [
    OrderExtraPaymentComponent,
  ]
})
export class OrderExtraPaymentModule { }
